import { useState } from "react";
import { FaArrowLeft, FaArrowRight } from "react-icons/fa";
import { motion, AnimatePresence } from "framer-motion";

const images = [
  "https://img.staticmb.com/mbphoto/property/cropped_images/2024/Sep/19/Photo_h470_w1080/74418401_12_20240918123413_470_1080.jpg",
  "https://img.staticmb.com/mbphoto/property/cropped_images/2024/Sep/19/Photo_h470_w1080/74418401_13_20240918123404_470_1080.jpg",
  "https://img.staticmb.com/mbphoto/property/cropped_images/2024/Sep/19/Photo_h470_w1080/74418401_14_20240918122935_470_1080.jpg",
  "https://img.staticmb.com/mbphoto/property/cropped_images/2024/Sep/19/Photo_h470_w1080/74418401_15_20240918122947_470_1080.jpg"
];

const ImageSlider = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [direction, setDirection] = useState(1);

  const nextSlide = () => {
    setDirection(1);
    setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
  };

  const prevSlide = () => {
    setDirection(-1);
    setCurrentIndex((prevIndex) => (prevIndex - 1 + images.length) % images.length);
  };

  return (
    <div className="relative w-full bg-black text-white p-4">
      <div className="relative flex justify-center items-center overflow-hidden w-full ">
        <button 
          onClick={prevSlide} 
          className="absolute left-4 p-2 bg-gray-800 rounded-full text-white z-10"
        >
          <FaArrowLeft size={20} />
        </button>

        {/* Image Transition Wrapper */}
        <div className="w-full h-[500px] overflow-hidden relative">
          <AnimatePresence custom={direction} initial={false}>
            <motion.div
              key={currentIndex}
              className="absolute top-0 left-0 w-full h-full"
              initial={{ x: direction * 100 + "%", opacity: 0 }}
              animate={{ x: "0%", opacity: 1 }}
              exit={{ x: -direction * 100 + "%", opacity: 0 }}
              transition={{ duration: 1, ease: "easeInOut" }}
            >
              <img 
                src={images[currentIndex]} 
                alt={`Slide ${currentIndex + 1}`} 
                className="w-full h-full object-contain rounded-lg"
              />
            </motion.div>
          </AnimatePresence>
        </div>

        <button 
          onClick={nextSlide} 
          className="absolute right-4 p-2 bg-gray-800 rounded-full text-white z-10"
        >
          <FaArrowRight size={20} />
        </button>
      </div>
      <div className="text-center mt-2 text-sm">
        {currentIndex + 1} / {images.length}
      </div>
    </div>
  );
};

export default ImageSlider;
